// import color from "../../../constants/color";

import color from "../../../../constants/color"

const styles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  TableHead: {
    color: "#878787",
    fontWeight: "400",
    whiteSpace: "nowrap"
  },

  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },

  tabledata: {
    borderBottom: 0,
    whiteSpace: "nowrap"
  },
  tableAvtardata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"

    },
    width: "29.2em"
  },
  reason: {
    borderRadius: "8px",

    width: "100%",
    mt: 1,
    height: "4.5em",
  },
  name: {
    color: color.text,
    fontSize: "14px",
    fontWeight: "400",
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  mail: {
    color: color.lightText,
    fontSize: "14px",
    fontWeight: "400"
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  profileAvtar: {
    mr: 1,
    border: "1px solid #878787",
    borderRadius: "50%",
    p: "9px",

  },
  filterButton: {
    display: "flex",
    backgroundColor: color.secondary,
    color: color.card,
    borderRadius: "30px",
    // width:{ xs: "50%", md: "20%" },
    marginLeft: { xs: 0, md: "8px" },
    alignItems: "center",
    paddingRight: 2,
    mb: { xs: "20px", md: 0 },

  },
  icon: {
    fill: color.card
  },
  filterContainer: {
    position: "relative"
  },
  StatBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    mb: { xs: 2, md: 2, lg: 0 },


  },
  StatBoxfirst: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    pb: "20px",
    mb: { xs: 2, md: 2, lg: 0 },

  },

  StatBoxs: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    mb: { xs: 2, md: 2, lg: 0 },

  },
  cards: {
    mt: 2
  },
  paygrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
  },
  dollarIcon: {
    color: color.primary,
    fontSize: "25px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    padding: "6px",
    width: "35px",
    height: "35px",
  },
  downloadIcon: {
    mr: 1,
  },
  downloadbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    // ml: { xs: 0, md: "10px" }, 
    fontSize: "12px",
  },
  paybtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    ml: { xs: 0, md: "10px" },
    fontSize: "12px",
  },


  gridContainer: {
    px: "15px",
    pt: "7px",
    pb: "25px",
    display: "flex",
    justifyContent: "space-between",
  },
  cardBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  monthlyText: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "400",

  },
  expandIcon: {
    color: color.lightText,
    display: "flex",


  },
  cardTitle: {
    color: color.text,
    fontWeight: "700",
    fontSize: "18px"
  },
  cardSubtitle:
  {
    color: color.lightText,
    fontWeight: "400",
    fontSize: "12px"
  },

  cardSubtitles:
  {
    color: color.lightText,
    fontWeight: "500",
    fontSize: "12px"
  },


}
export default styles
